import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'Components';
import AppContext from 'src/AppContext';
import './NavMobileItem.css';

const NavMobileItem = ({
  isPinned,
  value,
  hasPin,
  setAppState,
  filterItemValue,
  setNavState,
  isActive,
  togglePin,
}) => (
  <li className={`nav-mobile-item ${isActive ? 'nav-mobile-item--active' : ''}`}>
    <Button
      className={`nav-mobile-item__pin ${isPinned ? 'nav-mobile-item__pin--pinned' : ''}`}
      onClick={() => togglePin(value, isPinned)}
      style={hasPin ? {} : { visibility: 'hidden' }}
    >
      <i className="material-icons">{isPinned ? 'turned_in' : 'turned_in_not'}</i>
    </Button>
    <Button
      className="nav-mobile-item__link"
      onClick={() => setAppState(
        { filterItemValue },
        () => setNavState({ mobileActiveMenu: null }),
        )}
    >
      {value}
    </Button>
    { isActive && <div className="nav-mobile-item__triangle--active" /> }
  </li>
);

NavMobileItem.propTypes = {
  value: PropTypes.string,
  filterItemValue: PropTypes.string,
  isPinned: PropTypes.bool,
  hasPin: PropTypes.bool,
  isActive: PropTypes.bool,
  togglePin: PropTypes.func,
  setAppState: PropTypes.func,
  setNavState: PropTypes.func,
};

NavMobileItem.defaultProps = {
  hasPin: false,
  isActive: false,
};

export default (props => (
  <AppContext.Consumer>
    {context => (
      <NavMobileItem
        {...props}
        setAppState={context.setAppState}
      />)}
  </AppContext.Consumer>
));



// WEBPACK FOOTER //
// ./src/containers/Nav/NavMobile/NavMobileItem/NavMobileItem.jsx